jQuery(function ($) {
    var $win = $(window);
    var $toc = $('.contents-list');
    var $tocList = $toc.find('.contents-list__list ul');
    var $content = $('.col-blog-content');
    var $container = $toc.parent();
    var $blog = $('.blog-content');

    if (!$toc.length || !$content.length || !$blog.length) return;

    // ---- Helpers ----
    function headerOffset() {
        var base = 80; // dostosuj do wysokości headera
        var $admin = $('#wpadminbar');
        if ($admin.length) base += $admin.outerHeight();
        return base;
    }

    function slugify(str) {
        return (str || '')
            .toString()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
    }

    // ---- 1) Zbuduj TOC tylko gdy pusty ----
    function ensureTOC() {
        if ($tocList.children().length) return;
        var $headings = $blog.find('h2, h3');
        if (!$headings.length) return;

        $headings.each(function () {
            var $h = $(this);
            var tag = this.tagName.toLowerCase();
            var level = tag === 'h3' ? 3 : 2;
            var text = $.trim($h.text());
            var id = $h.attr('id');

            if (!id) {
                id = slugify(text) || 'sekcja';
                var base = id, n = 2;
                while (document.getElementById(id)) id = base + '-' + (n++);
                $h.attr('id', id);
            }

            $('<li/>', { 'class': 'toc-level-' + level })
                .append($('<a/>', { href: '#' + id, text: text }))
                .appendTo($tocList);
        });
    }
    ensureTOC();

    // ---- 2) Smooth scroll (delegacja globalna + natywne przewijanie) ----
    $(document).on('click', '.contents-list__list a', function (e) {
        var href = $(this).attr('href') || '';
        if (href.indexOf('#') === -1) return; // brak hash -> nie ruszamy

        var id = decodeURIComponent(href.split('#').pop());
        if (!id) return;

        var el = document.getElementById(id);
        if (!el) return;

        e.preventDefault();
        e.stopPropagation();

        var top = $(el).offset().top - headerOffset();

        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
            // aktualizacja hash bez „skoku”
            if (history.replaceState) history.replaceState(null, '', '#' + id);
        } else {
            $('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, 500, function () {
                if (history.replaceState) history.replaceState(null, '', '#' + id);
            });
        }
    });

    // ---- 3) Podświetlanie aktywnej sekcji ----
    function setActive(id) {
        if (!id) return;
        $tocList.find('a').each(function () {
            var $a = $(this);
            var match = ($a.attr('href') === '#' + id);
            $a.toggleClass('is-active', match);
            $a.closest('li').toggleClass('is-active', match);
        });
    }

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) setActive(entry.target.id);
            });
        }, {
            rootMargin: '-' + headerOffset() + 'px 0px -60% 0px',
            threshold: [0, 1]
        });
        $blog.find('h2[id], h3[id]').each(function () { observer.observe(this); });
    } else {
        var $heads = $blog.find('h2[id], h3[id]');
        function updateActiveOnScroll() {
            var top = $win.scrollTop() + headerOffset() + 10;
            var currentId = null;
            $heads.each(function () {
                if ($(this).offset().top <= top) currentId = this.id;
                else return false;
            });
            setActive(currentId);
        }
        $win.on('scroll', updateActiveOnScroll);
        updateActiveOnScroll();
    }

    // ---- 4) Sticky (desktop >= 992px) ----
    var metrics = { tocTop: 0, tocH: 0, stopY: 0, fixedTop: 70 };

    function calcMetrics() {
        $toc.css({ position: 'static', top: '', width: '' });
        metrics.tocTop   = $toc.offset().top;
        metrics.tocH     = $toc.outerHeight(true);
        metrics.fixedTop = 20;
        var contentTop   = $content.offset().top;
        var contentH     = $content.outerHeight(true);
        metrics.stopY    = contentTop + contentH - metrics.tocH;
    }

    var ticking = false;
    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
            ticking = false;

            if (window.innerWidth < 992) {
                $toc.css({ position: 'static', top: '', width: '' });
                return;
            }

            var st = $win.scrollTop();
            var topLimit = metrics.tocTop;
            var fixedTop = metrics.fixedTop + ($('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0);
            var width = $container.width();

            if (st >= topLimit && (st + fixedTop) < metrics.stopY) {
                $toc.css({ position: 'fixed', top: fixedTop + 'px', width: width + 'px' });
            } else if ((st + fixedTop) >= metrics.stopY) {
                $toc.css({
                    position: 'absolute',
                    top: (metrics.stopY - metrics.tocTop) + 'px',
                    width: width + 'px'
                });
            } else {
                $toc.css({ position: 'static', top: '', width: '' });
            }
        });
    }

    function onResize() {
        calcMetrics();
        onScroll();
    }

    $(window).on('load', function () { calcMetrics(); onScroll(); });
    $(window).on('scroll', onScroll);
    $(window).on('resize orientationchange', function () {
        clearTimeout(window.__wbdm_resize_to);
        window.__wbdm_resize_to = setTimeout(onResize, 100);
    });
    setTimeout(onResize, 600);
    setTimeout(onResize, 2000);
});
